
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { Field, DropdownField } from '@samc/centricity-core';
  import { UserSource, UserByRoleSource } from '@/Sources';

  @Component({
    name: 'user-dropdown-field',
    components: { Field, DropdownField }
  })
  export default class UserDropdownField extends Vue {
    @Prop() public value!: string;
    @Prop({ default: 'User' }) public label!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
    @Prop() public placeholder!: string;
    @Prop({ default: null }) public role!: string | null;
    @Prop({ default: '' }) public errorText!: string;

    public source: UserSource | UserByRoleSource = new UserSource();

    public async mounted() {
      if (this.role !== null) {
        this.source = new UserByRoleSource(this.role);
      } else {
        this.source = new UserSource();
      }
    }

    public get val(): string { return this.value; }
    public set val(value: string) {
      this.$emit('input', value);
    }
  }
